var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label":((_vm.label === null
        ? null
        : _vm.label
        ? _vm.translateLabel
          ? _vm.$t(_vm.label)
          : _vm.label
        : _vm.$t(_vm.varname)) + ":"),"label-class":"text-nowrap","label-for":_vm.varname,"state":_vm.errors[_vm.varname] ? false : null,"invalid-feedback":_vm.feedback(_vm.errors[_vm.varname]),"description":_vm.$t(_vm.description) || null}},[_c(_vm.tagname,_vm._b({tag:"component",staticStyle:{"min-width":"100px"},attrs:{"id":_vm.varname,"name":_vm.varname,"value":_vm.value,"state":_vm.errors[_vm.varname] ? false : null},on:{"input":function($event){return _vm.$emit('input', $event)}}},'component',_vm.$attrs,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }